import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";

import MainMenu from "../../components/MainMenu";
import DMPTitleBar from "../../components/TitleBar/DMPTitleBar";
import DmpPlayerList from "./PlayerList";
import DmpCreate from "./DmpCreate";

import {
  clearDmpLists,
  clearSelectedDMPLeague,
  clearSelectedDMPLeagueID,
  getDmpLists,
  getSelectedDMPLeague,
  getSelectedDMPLeagueId,
} from "../../redux/actions/dmp-actions";

const makeRounds = (n = 16) => {
  let arr = [];
  let i = n;

  while (i >= 1) {
    switch (i) {
      case 8:
        arr.push({ rounds: Math.ceil(i), label: "Quarter - Finals" });
        break;

      case 4:
        arr.push({ rounds: Math.ceil(i), label: "Semi - Finals" });
        break;

      case 2:
        arr.push({ rounds: Math.ceil(i), label: "Finals" });
        break;
      case 1:
        arr.push({ rounds: Math.ceil(1), label: "Winner" });
        break;

      default:
        arr.push({ rounds: Math.ceil(i), label: `Round of ${Math.ceil(i)}` });
        break;
    }

    i /= 2;
  }

  return arr;
};

const DMP = () => {
  const dispatch = useDispatch();

  const createdPlayerList = useSelector((state) => state?.createDmpListReducer);
  const aboutLeague = useSelector((state) => state?.getDmpList?.data);

  const selectedDMPSelector = useSelector(
    (state) => state.getSelectedDMPLeagueReducer
  );

  let no_of_teams = selectedDMPSelector?.data?.leageData
    ? selectedDMPSelector?.data?.leageData[0]?.season_description?.no_of_teams
    : 0;

  let list = makeRounds(no_of_teams);

  const [toggleView, setToggleView] = useState(true);
  const [leagueId, setLeagueId] = useState(null);

  // Handle DMP League change
  const handleLeagueId = (value) => {
    dispatch(getSelectedDMPLeagueId(value));
  };

  // Get All DMP Leagues List
  useEffect(() => {
    dispatch(getDmpLists());

    return () => {
      dispatch(clearSelectedDMPLeague());
      dispatch(clearSelectedDMPLeagueID());
      dispatch(clearDmpLists());
    };
  }, []);

  // Set Latest LeagueId on first render
  useEffect(() => {
    if (aboutLeague?.leagues) {
      if (aboutLeague?.leagues.length > 0 && selectedDMPSelector.id === null) {
        dispatch(getSelectedDMPLeagueId(aboutLeague?.leagues[0]._id));
      }
    }
  }, [aboutLeague]);

  // Get Selected League Data
  useEffect(() => {
    if (leagueId != null) {
      dispatch(getSelectedDMPLeague(leagueId));
    }
  }, [toggleView, leagueId]);

  // Set Dropdown Selected League ID
  useEffect(() => {
    if (selectedDMPSelector.id !== null) {
      setLeagueId(selectedDMPSelector.id);
    }
  }, [selectedDMPSelector]);

  return (
    <MainMenu>
      <Box
        sx={{
          backgroundColor: "white",
          padding: "30px",
          borderRadius: "10px",
          boxShadow: 3,
        }}
      >
        <DMPTitleBar
          handleToggle={() => {
            if (no_of_teams > 0) {
              setToggleView(!toggleView);
            }
          }}
          name="Double Match Play"
          show={toggleView}
          leagueId={leagueId}
          handleLeagueId={handleLeagueId}
        />

        {toggleView ? (
          <Box>
            <DmpPlayerList
              list={list}
              no_of_teams={no_of_teams}
              leagueId={leagueId}
            />
          </Box>
        ) : (
          <DmpCreate
            createdPlayerList={createdPlayerList}
            setToggleView={setToggleView}
            leagueId={leagueId}
          />
        )}
      </Box>
    </MainMenu>
  );
};

export default DMP;
